JST["quick-cart-home-trial-empty-cart"] = function anonymous(it
) {
var out='<li class="home-trial__empty-cart p-1 mb-1"> <div class="m-1 p-2 text-bold text-normal text-center"> '+( texts('noItemMessage@cartPage'))+' </div></li>';return out;
};